import axios, {AxiosError, AxiosRequestConfig} from 'axios';

import i18n from 'i18next';
import {ROUTES} from 'routes/nonfrov/constants';
import {LOCAL_STORAGE_NEFROV_STAND_KEY} from '../common/api/constants';

export const nefrovStand =
  window.localStorage.getItem(LOCAL_STORAGE_NEFROV_STAND_KEY) || `${import.meta.env.VITE_APP_API}/nefrov-api`;

export const AXIOS_INSTANCE_NEFROV = axios.create({
  timeout: 300000,
  baseURL: nefrovStand,
});

export const customInstanceNefrov = <T>(config: AxiosRequestConfig): Promise<T> => {
  const lang = i18n.language === 'ru' ? 'ru-RU' : 'en';
  const source = axios.CancelToken.source();

  return AXIOS_INSTANCE_NEFROV({
    ...config,
    headers: {
      'Accept-Language': lang,
    },
    cancelToken: source.token,
  }).then(response => {
    if (response.status === 400) {
      throw new Error(JSON.stringify(response.data));
    } else if (response.status > 400) {
      // костыль, чтобы при логине не обновляло страницу
      // TODO переделать страницу error
      if (window.location.pathname === '/') {
        throw new Error(JSON.stringify(response.data));
      } else {
        window.location.pathname = `${ROUTES.ERROR}/${response.status}`;
      }
    } else {
      return response.data;
    }
  });
};

export default customInstanceNefrov;

export type ErrorType<Error> = AxiosError<Error>;
